import { render } from "./ConfirmationPopupLocalization.vue?vue&type=template&id=b39983d0"
import script from "./ConfirmationPopupLocalization.vue?vue&type=script&lang=js"
export * from "./ConfirmationPopupLocalization.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__